<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - Atendimento</h3>
      </div>
    </div>
    <Tables
      ref="tableGrid"
      :columns="columns"
      :showSearch="true"
      :showReload="false"
      :showTipFooter="false"
      v-on:Search="onShowSearch"
      v-on:Load="onLoad"
      :showPaging="false"
      v-on:Reload="onLoad"
    >
      <template slot="table-header-buttons">
        <a
          href="javascript:void(0);"
          v-b-tooltip.hover
          :title="'Exportar'"
          @click="onExportExcel"
        >
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
      </template>
      <template slot="table-header-buttons">
        <a href="javascript:void(0);" id="popover-report-collumn">
          <i class="fas fa-columns text-third" style="font-size: 15px"></i>
        </a>
        <b-popover target="popover-report-collumn" triggers="hover" placement="bottomleft">
          <template #title>Adicionar/ Remover Colunas</template>
          <div class="pb-3">
            <div class="pb-3" style="font-size:9px">
              Clique para adicionar/ remover colunas na grid
            </div>
            <div class="pl-4" >
              <div v-for="(item,index) in columnsOpt" :key="index">
                <b-form-checkbox v-model="item.value" name="check-button" switch @change="setVisibleColumns">
                  {{item.label}}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </b-popover>
      </template>
      <tr v-for="obj in objList" v-bind:key="obj.id">
        <template>
          <div @click="openAttachModalMessages(obj.conversationId, obj.provider, obj.identifierProvider)">
            <TableColumn
              v-if="columnsOpt[0].value"
              :IsText="true"
              :status="obj.inative ? 0 : 1"
              :value="obj.protocolo ? obj.protocolo : 'NÃO POSSUI'"
            />
          </div>
          <TableColumn
            v-if="columnsOpt[1].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="
              obj.dataAbertura
                ? formatDateAndTime(obj.dataAbertura)
                : 'NÃO POSSUI'
            "
          />
          <TableColumn
            v-if="columnsOpt[2].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.operador ? obj.operador : 'NÃO POSSUI'"
          />
          <TableColumn
            v-if="columnsOpt[3].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.nome ? obj.nome : 'NÃO POSSUI'"
          />
          <TableColumn
            v-if="columnsOpt[4].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.numeroTelefone ? obj.numeroTelefone : 'NÃO POSSUI'"
          />
          <TableColumn
            v-if="columnsOpt[5].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="
              obj.numeroPA ? obj.nomePa + ' - ' + obj.numeroPA : 'NÃO POSSUI'
            "
          />
          <TableColumn
            v-if="columnsOpt[6].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="
              obj.dataFinalizacao
                ? formatDateAndTime(obj.dataFinalizacao)
                : 'NÃO POSSUI'
            "
          />
          <TableColumn
            v-if="columnsOpt[7].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.tipoFinalizacao ? obj.tipoFinalizacao : 'NÃO POSSUI'"
          />
          <TableColumn
            v-if="columnsOpt[8].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="
              obj.tempoEspera ? formatTime(obj.tempoEspera) : 'NÃO POSSUI'
            "
          />
          <TableColumn
            v-if="columnsOpt[9].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="
              obj.tempoAtendimento
                ? formatTime(obj.tempoAtendimento)
                : 'NÃO POSSUI'
            "
          />
          <TableColumn
            v-if="columnsOpt[10].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.notaAtendimento ? obj.notaAtendimento : 'NÃO POSSUI'"
          />
          <TableColumn
            v-if="columnsOpt[11].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="formatCondicao(obj.condicao)"
          />
          <TableColumn
            v-if="columnsOpt[12].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.tipoDeInicializacao ? obj.tipoDeInicializacao : 'NÃO IDENTIFICADO'"
          />
          <TableColumn
            v-if="columnsOpt[13].value"
            :IsText="true"
            :status="obj.inative ? 0 : 1"
            :value="obj.identifierProvider ? obj.identifierProvider : ' - '"
          />
        </template>
      </tr>
    </Tables>

    <div class="pagination-controls">
      <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-center">
          <li class="page-item">
            <a
              @click="goToFirstPage"
              :disabled="filters.page <= 1"
              class="page-link"
              href="#"
              >Primeira</a
            >
          </li>
          <li class="page-item">
            <a
              @click="previousPage"
              :disabled="filters.page <= 1"
              class="page-link"
              href="#"
              >Anterior</a
            >
          </li>
          <li
            v-for="page in getPageRange()"
            :key="page"
            :class="['page-item', { active: page === filters.page }]"
          >
            <a @click="goToPage(page)" class="page-link" href="#">{{ page }}</a>
          </li>
          <li class="page-item">
            <a
              @click="nextPage"
              :disabled="filters.page >= totalPages"
              class="page-link"
              href="#"
              >Próximo</a
            >
          </li>
          <li class="page-item">
            <a
              @click="goToLastPage"
              :disabled="filters.page >= totalPages"
              class="page-link"
              href="#"
              >Última</a
            >
          </li>
          <ul class="pagination justify-content-center">
            <span class="page-link">
              {{ filters.page }} de {{ totalPages }}
            </span>
          </ul>
        </ul>
      </nav>
    </div>

    <SidebarSearch @search="onSearch" />
    <MessagesModal ref="messagesModal" :btnRelatorio="true" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import ReportAtendimentoRepository from '@/shared/http/repositories/crm/reportAtendimento.js'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import PARepository from '@/shared/http/repositories/configurations/pa.js'

import {
  NxDataGrid,
  NxDataGridColumn,
  NxDataGridItem
} from '@/components/nexum/components'
import SidebarSearch from '@/views/private/atendimento/relatorios_atendimento/search/SidebarRelatorioAtendimento.vue'
import MessagesModal from '@/views/private/atendimento/components/modal/MessageModals.vue'

export default {
  name: 'ReportAtendimento',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      totalPages: null,
      localData: [],
      filters: {
        nome: null,
        numeroPA: null,
        numeroTelefone: null,
        tipoFinalizacao: null,
        identifierProvider: null,
        dataInicial: null,
        dataFinal: null,
        operadores: null,
        status: 'Finalizado',
        page: 1,
        pageSize: 10,
        protocols: null
      },
      columns: [],
      columnsOpt: [
        { value: true, label: 'PROTOCOLO' },
        { value: true, label: 'DATA DE ABERTURA' },
        { value: true, label: 'ATENDENTE' },
        { value: true, label: 'CLIENTE - NOME' },
        { value: true, label: 'NÚMERO DE CELULAR' },
        { value: true, label: 'PA' },
        { value: true, label: 'DATA DE FECHAMENTO' },
        { value: true, label: 'MOTIVO FINALIZAÇÃO' },
        { value: true, label: 'TEMPO DE ESPERA' },
        { value: true, label: 'TEMPO DE ATENDIMENTO' },
        { value: true, label: 'NOTA DE ATENDIMENTO' },
        { value: true, label: 'CONDIÇÃO DE FINALIZAÇÃO' },
        { value: true, label: 'TIPO DE INICIALIZAÇÃO' },
        { value: true, label: 'ORIGEM PROVEDOR' }
      ],
      pageSizeOptions: [
        { value: 5, text: '5 por página' },
        { value: 10, text: '10 por página' },
        { value: 20, text: '20 por página' },
        { value: 50, text: '50 por página' }
      ],
      selectedCard: null
    }
  },
  components: {
    NxDataGrid,
    NxDataGridColumn,
    NxDataGridItem,
    SidebarSearch,
    MessagesModal
  },
  methods: {
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.getPages()
        this.onLoadAll()
        this.onColumnsOpt()
        this.setVisibleColumns()
      })
    },
    openAttachModalMessages (conversationId, provider, identifierProvider) {
      this.$refs.messagesModal.openModal(conversationId, provider, identifierProvider)
    },
    onLoad () {
      this.setVisibleColumns()
      if (this.filters) {
        this.onLoadAll()
      }
      this.getPages()
      this.onLoadAll()
    },
    load (params) {
      return ReportAtendimentoRepository.GetAll(this.filters, { params })
    },
    clearData () {
      this.localData = []
    },
    getPageRange () {
      const totalPages = this.totalPages || 1
      const range = 5
      let startPage = Math.max(1, this.filters.page - range)
      let endPage = Math.min(totalPages, this.filters.page + range)

      if (endPage - startPage < range * 2) {
        if (startPage === 1) {
          endPage = Math.min(totalPages, startPage + range * 2)
        } else {
          startPage = Math.max(1, endPage - range * 2)
        }
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      )
    },

    goToPage (page) {
      this.filters.page = page
      this.clearData()
      this.onLoadAll()
    },

    previousPage () {
      if (this.filters.page > 1) {
        this.filters.page--
        this.clearData()
        this.onLoadAll()
      }
    },

    nextPage () {
      if (this.filters.page < this.totalPages) {
        this.filters.page++
        this.clearData()
        this.onLoadAll()
      }
    },
    goToFirstPage () {
      if (this.filters.page !== 1) {
        this.filters.page = 1
        this.clearData()
        this.onLoadAll()
      }
    },
    goToLastPage () {
      if (this.filters.page !== this.totalPages) {
        this.filters.page = this.totalPages
        this.clearData()
        this.onLoadAll()
      }
    },
    async getPages () {
      const requestConfigPages = {
        name: this.filters.nome,
        protocol: this.filters.protocolo,
        status: this.filters.status,
        operatorId: this.filters.operadores,
        startDate: this.filters.dataInicial
          ? new Date(this.filters.dataInicial).toISOString()
          : null,
        endDate: this.filters.dataFinal
          ? new Date(this.filters.dataFinal).toISOString()
          : null,
        typeFinalization: this.filters.tipoFinalizacao,
        identifier: this.filters.numeroTelefone,
        protocols: this.filters.protocols
      }

      return AtendimentoRepository.GetPages(
        this.filters,
        requestConfigPages
      ).then(response => {
        const { status, data } = response

        if (status === 200) {
          this.countsConversation = data.count
          this.totalPages = Math.ceil(
            this.countsConversation / this.filters.pageSize
          )
        }
      })
    },
    onLoadAll () {
      loading.push()
      ReportAtendimentoRepository.GetAll(this.filters)
        .then(response => {
          const responseCerto = {
            data: {
              content: response.data,
              totalElements: response.data.length,
              number: 0,
              pagingLimit: this.filters.pageSize
            },
            status: 200
          }
          this.onResultGrid(responseCerto)
        })
        .catch(this.onException)
        .finally(() => loading.close())
    },
    onLoadPAs () {
      PARepository.GetAll()
        .then(response => {
          let result = response.data.content.map(x => ({
            value: x.numero,
            text: x.descricao
          }))
          this.form.numeroPA.listOptions = result
        })
        .catch(this.onException)
    },
    onExportExcel () {
      loading.push()
      ReportAtendimentoRepository.ExportAllCardsReport(this.filters)
        .then(response => {
          const base64 = response.data

          function base64ToArrayBuffer (base64) {
            const binaryString = window.atob(base64)
            const len = binaryString.length
            const bytes = new Uint8Array(len)
            for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i)
            }
            return bytes.buffer
          }

          const fileStartName = this.moment().format('YYYYMMDDHHmm')
          const arrayBuffer = base64ToArrayBuffer(base64)

          const blob = new Blob([arrayBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = `${fileStartName}_RelatorioAtendimento.xlsx`
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)
        .finally(() => loading.close())
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    formatProviderPhoneNumber (number) {
      if (!number) return null

      const cleaned = number.toString().replace(/\D/g, '')

      // Verifica se é um número válido com DDI, DDD e número
      const match = cleaned.match(/^(\d{2})(\d{2})(\d{5})(\d{4})$/)
      if (match) {
        return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`
      }
      return number
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    },
    reloadGrid () {
      this.onLoad()
    },
    formatDateAndTime (rawDate) {
      const date = new Date(rawDate)
      const day = date
        .getDate()
        .toString()
        .padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date
        .getHours()
        .toString()
        .padStart(2, '0')
      const minutes = date
        .getMinutes()
        .toString()
        .padStart(2, '0')

      return `${day}/${month}/${year} às ${hours}:${minutes}`
    },
    onLimitCarac (text) {
      return text.length > 100 ? text.substring(0, 100).concat('...') : text
    },
    formatTime (milliseconds) {
      const hours = Math.floor(milliseconds / 3600000)
      const minutes = Math.floor((milliseconds % 3600000) / 60000)
      const seconds = Math.floor((milliseconds % 60000) / 1000)

      let timeString = ''

      if (hours > 0) {
        timeString += `${hours} hora${hours > 1 ? 's' : ''} `
      }

      if (minutes > 0 || hours > 0) {
        timeString += `${minutes} minuto${minutes > 1 ? 's' : ''} `
      }

      if (seconds > 0 || minutes > 0 || hours > 0) {
        timeString += `${seconds} segundo${seconds > 1 ? 's' : ''}`
      }

      return timeString.trim()
    },
    formatCondicao (condicao) {
      if (condicao === null) {
        return 'NEUTRO'
      } else if (condicao) {
        return 'POSITIVO'
      } else {
        return 'NEGATIVO'
      }
    },
    pad (number) {
      return number < 10 ? '0' + number : number
    },
    padMilliseconds (milliseconds) {
      return milliseconds < 100
        ? milliseconds < 10
          ? '00' + milliseconds
          : '0' + milliseconds
        : milliseconds
    },
    setVisibleColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        if (this.columnsOpt[i].value) {
          this.columns.push(this.columnsOpt[i].label)
        }
      }
    },
    onColumnsOpt () {
      if (this.filters.status === 'Finalizado') {
        this.columnsOpt = [
          { value: true, label: 'PROTOCOLO' },
          { value: true, label: 'DATA DE ABERTURA' },
          { value: true, label: 'ATENDENTE' },
          { value: true, label: 'CLIENTE - NOME' },
          { value: true, label: 'NÚMERO DE CELULAR' },
          { value: true, label: 'PA' },
          { value: true, label: 'DATA DE FECHAMENTO' },
          { value: true, label: 'MOTIVO FINALIZAÇÃO' },
          { value: true, label: 'TEMPO DE ESPERA' },
          { value: true, label: 'TEMPO DE ATENDIMENTO' },
          { value: true, label: 'NOTA DE ATENDIMENTO' },
          { value: true, label: 'CONDIÇÃO DE FINALIZAÇÃO' },
          { value: true, label: 'TIPO DE INICIALIZAÇÃO' },
          { value: true, label: 'ORIGEM DO PROVEDOR' }
        ]
      } else {
        this.filters.status = 'Aberto'
        this.columnsOpt = [
          { value: true, label: 'PROTOCOLO' },
          { value: true, label: 'DATA DE ABERTURA' },
          { value: true, label: 'ATENDENTE' },
          { value: true, label: 'CLIENTE - NOME' },
          { value: true, label: 'NÚMERO DE CELULAR' },
          { value: true, label: 'PA' },
          { value: false, label: 'DATA DE FECHAMENTO' },
          { value: false, label: 'MOTIVO FINALIZAÇÃO' },
          { value: true, label: 'TEMPO DE ESPERA' },
          { value: false, label: 'TEMPO DE ATENDIMENTO' },
          { value: false, label: 'NOTA DE ATENDIMENTO' },
          { value: false, label: 'CONDIÇÃO DE FINALIZAÇÃO' },
          { value: true, label: 'TIPO DE INICIALIZAÇÃO' },
          { value: true, label: 'ORIGEM DO PROVEDOR' }
        ]
      }
    },
    onPageSizeChange () {
      this.filters.page = 1
      this.clearData()
      this.onLoadAll()
    }
  }
}
</script>

<style>
  .popover-header {
    background-color: #04a791;
    color: #eceff1;
  }
  .pagination .page-item.active .page-link {
    background-color: #04a791;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/relatorios_atendimento/ReportAtendimento.vue